import React from 'react';

import { usePreAssembledBasketType } from 'app/containers/contexts/filters.context/usePreAssembledBasketType';
import { useURLUpdater } from 'global/utils/URLUpdater';

type checkFn = () => boolean;
type mutateFn = () => void

type hookTuple = [checkFn, mutateFn]

const paramsToRemove = [
    'cm',
    'menu',
    'extra',
];

export const useSetsCartMutations = (): hookTuple => {
    const typeOfSet = usePreAssembledBasketType();
    const updateUrl = useURLUpdater();

    const checkSetsParams = (): boolean => {
        const isSet = typeOfSet === 'top';
        const isEveryday = typeOfSet === 'every';
        const isGreen = typeOfSet === 'green';
        return isSet || isEveryday || isGreen;
    };

    const removeSetsParams = (): void => {
        const paramsToSet = paramsToRemove
            .reduce((acc, param) => {
                acc[param] = null;
                return acc;
            }, {} as Record<string, any>);
        updateUrl(paramsToSet, null, true);
    };

    return [checkSetsParams, removeSetsParams];
};
